<template>
   <v-app>
        <v-container align="center">
            <v-row>
                <v-col cols="12">
                    <v-card align="center" flat>
                        
                            <v-col cols="12" md="8">
                                <h1> Usted creo el usuario con exito
                                </h1>
                            </v-col>
                            <v-col cols="12" md="8">
                                <h3> Se ha enviado un mail de confirmacion a su correo electronico.
                                </h3>
                            </v-col>
                            <v-col cols="12" md="8">
                                <h3> Antes de iniciar sesion, confirme el mail que le hemos enviado.
                                </h3>
                            </v-col>    
        
                    </v-card>
                </v-col>   
            </v-row> 
        </v-container>
   </v-app>
</template>

<script>
//import axios from 'axios';
//import AxiosError from 'axios'

    export default {
        name: 'signupsuccess',
        data() {
            return {
                
            }
        },
        
    }
</script>